import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _isEmpty from 'lodash/isEmpty';
import _set from 'lodash/set';

import Col from 'ravenjs/lib/Col';
import Row from 'ravenjs/lib/Row';
import Select from 'ravenjs/lib/Select';

import { callFunc, getHandler, get } from 'ravenjs/utils';
import FormGroupTitle from './FormGroupTitle';

class LegislationComplyTopicsField extends Component {
    constructor(props) {
        super(props);

        const { formData, schema, uiSchema } = this.props;
        const safeFormData = formData || [];
        const id = get(schema, 'title').replace(/ /g, '');
        this.idComponent = `${id.charAt(0).toLowerCase()}${id.slice(1)}`;
        const { hrTopics } = get(uiSchema, 'ui:options', {});
        const formattedTopics = safeFormData.map(topic => ({
            value: topic.value,
            label: topic.value,
        }));
        const defaultOptions = hrTopics.map(option => {
            option.label = option.value;
            return option;
        });

        this.state = {
            defaultOptions,
            formattedTopics,
            formData: safeFormData,
        };
    }

    /**
     * Styles for the hidden `input` element
     *
     * @method getHiddenInputStyle
     * @return {Object}
     */

    getHiddenInputStyle = () => ({
        height: 38,
        opacity: 0,
        overflow: 'hidden',
        position: 'absolute',
        top: 0,
        width: '100%',
        zIndex: -1,
    });

    handleOnChange = options => {
        const newTopics = options.map(option => {
            return { value: option.value };
        });

        const formattedTopics = options.map(topic => {
            return { value: topic.value, label: topic.value };
        });
        this.setState({
            formattedTopics,
            formData: newTopics,
        });
    };

    handleOnBlur = evt => {
        const { currentTarget } = evt;
        const { formContext } = this.props;
        const updatedFormData = { ...formContext.getFormData() };
        const { idComponent } = this;
        const { handlers = {} } = formContext;
        const updateTopics = getHandler(handlers, 'updateTopics');
        const { formData: topics } = this.state;

        setTimeout(() => {
            if (!currentTarget.contains(document.activeElement)) {
                callFunc(updateTopics, {
                    topics,
                });
            }
        }, 0);

        Object.keys(updatedFormData).forEach(key => {
            if (typeof updatedFormData[key] === 'object') {
                if (idComponent in updatedFormData[key]) {
                    _set(updatedFormData[key], idComponent, topics);
                }
            }
        });

        // Update the form with the newly set data
        formContext.updateFormData({ formData: updatedFormData });
    };

    render() {
        const { defaultOptions, formattedTopics } = this.state;
        const { idSchema, required, schema } = this.props;
        const id = get(idSchema, '$id', '');
        const title = get(schema, 'title', '');
        const titleHelptext = get(schema, 'helpText', {});
        const hiddenInputValue = !_isEmpty(formattedTopics) ? JSON.stringify(formattedTopics) : '';

        return (
            <Row width="auto">
                <Col size={12}>
                    <FormGroupTitle
                        helpText={titleHelptext}
                        id={id}
                        required={required && Boolean(!formattedTopics)}
                        title={title}
                    />
                </Col>
                <Col size={12} style={{ position: 'relative' }}>
                    <Select
                        defaultValue={formattedTopics}
                        isMulti
                        isClearable={false}
                        minControlHeight={30}
                        onBlur={this.handleOnBlur}
                        onChange={this.handleOnChange}
                        options={defaultOptions}
                        placeholder=""
                        customMenuPosition="relative"
                    />
                    <input
                        id={id}
                        onChange={() => {}}
                        required={required}
                        style={this.getHiddenInputStyle()}
                        tabIndex={-1}
                        type="text"
                        value={hiddenInputValue}
                    />
                </Col>
            </Row>
        );
    }
}

LegislationComplyTopicsField.propTypes = {
    formContext: PropTypes.object,
    formData: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
    idSchema: PropTypes.object,
    required: PropTypes.bool,
    schema: PropTypes.object,
    uiSchema: PropTypes.object,
};

LegislationComplyTopicsField.defaultProps = {
    formContext: null,
    formData: null,
    idSchema: null,
    required: null,
    schema: null,
    uiSchema: null,
};

export default LegislationComplyTopicsField;
